import { render, staticRenderFns } from "./SimpleChart.vue?vue&type=template&id=b40e1e6a&scoped=true"
import script from "./SimpleChart.vue?vue&type=script&lang=js"
export * from "./SimpleChart.vue?vue&type=script&lang=js"
import style0 from "./SimpleChart.vue?vue&type=style&index=0&id=b40e1e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40e1e6a",
  null
  
)

export default component.exports